import { render, staticRenderFns } from "./ProductEnhance.vue?vue&type=template&id=2510db2d&scoped=true&"
import script from "./ProductEnhance.vue?vue&type=script&lang=js&"
export * from "./ProductEnhance.vue?vue&type=script&lang=js&"
import style0 from "./ProductEnhance.vue?vue&type=style&index=0&id=2510db2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510db2d",
  null
  
)

export default component.exports